export const mapPharmacyInfo = (response) => {
    return response?.data?.value?.resultItems;
};
export const mapSingleDataOfPharmacyPersonalInfo = (response) => {
    return response.value.resultItems;
};
